import { OERateDataModel } from "./oe-rate-data.model";

export class OERateTransportModel {
  public refIds: Array<string> = null;
  public value: OERateDataModel = null;

  constructor(refIds: Array<string>, value: OERateDataModel) {
    if (refIds instanceof Array && refIds.length > 0 && value instanceof OERateDataModel) {
      this.refIds = refIds;
      this.value = value;
    } else {
      throw new Error(`Invalid refIds list or invalid RateData model.`);
    }
  }
}
